import React, { useEffect, useState } from "react";
import { useL } from "@/lib/useL";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { QcmTools } from "@/components/QcmTools";

// Adds a small « Retirer » cross next to each « Complément : … » heading of a rendered summary.
export function ComplementRemovers({ articleRef, summaryId, summary, onChange, title }) {
  const [targets, setTargets] = useState([]);
  const L = useL();

  useEffect(() => {
    const el = articleRef.current;
    if (!el) return;
    const heads = Array.from(el.querySelectorAll("h1, h2, h3")).filter((h) => /^Complément\s*:/i.test(h.textContent.trim()));
    const slots = heads.map((h) => {
      const span = document.createElement("span");
      span.className = "flex flex-wrap items-center gap-2 mt-2 print:hidden font-normal text-base normal-case tracking-normal";
      h.appendChild(span);
      return span;
    });
    setTargets(slots);
    return () => slots.forEach((s) => s.remove());
  }, [articleRef, summary]);

  const remove = async (index) => {
    if (!window.confirm(L("Retirer ce complément du résumé ?", "Remove this addition from the summary?"))) return;
    try {
      const { data } = await api.post(`/summaries/${summaryId}/remove-complement`, { index });
      onChange(data.summary);
      toast.success(L("Complément retiré.", "Addition removed."));
    } catch {
      toast.error(L("Impossible de retirer ce complément.", "Could not remove this addition."));
    }
  };

  const sections = (summary || "").split(/\n\n(?=## Complément : )/).slice(1).map((s) => s.replace(/^## Complément : .*\n/, ""));
  return targets.map((slot, i) =>
    createPortal(
      <span className="contents">
      <button
        type="button"
        onClick={() => remove(i)}
        data-testid={`complement-remove-${i}`}
        data-tip={L("Retirer ce complément du résumé", "Remove this addition from the summary")}
        aria-label={L("Retirer ce complément", "Remove this addition")}
        className="inline-flex items-center gap-1 font-mono uppercase tracking-[0.12em] text-[10px] px-2 py-1 border border-border text-muted-foreground hover:border-[#FF2A00] hover:text-[#FF2A00] transition-colors"
      >
        <X className="w-3 h-3" /> {L("Retirer", "Remove")}
      </button>
      {sections[i] && <QcmTools text={sections[i]} title={title} summaryId={summaryId} testid={`complement-qcm-${i}`} />}
      </span>,
      slot,
      `c-${i}`
    )
  );
}

export default ComplementRemovers;
